import React from 'react';
import clsx from 'clsx';
import { has } from '../../services/classify';
import { hashClass } from '../../helpers';
import { useTrilogyContext } from '../../context';
/**
 * Stepper Component
 * @param className Additionnal CSS Classes
 * @param centered Center the stepper
 * @param children {ReactNode}
 */
const Stepper = ({ className, centered, children, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('stepper-wrapper', className));
    const centerClasses = hashClass(styled, clsx('section', has('text-centered'), className));
    const [currentStep, setCurrentStep] = React.useState(0);
    const nbChild = React.useMemo(() => {
        if (children && Array.isArray(children))
            return children.length;
        if (children && !Array.isArray(children))
            return 1;
        return 0;
    }, [children]);
    React.useEffect(() => {
        if (children) {
            if (Array.isArray(children)) {
                let haveCurrentStep = false;
                children.map((child) => {
                    if (child.props.current) {
                        haveCurrentStep = true;
                        setCurrentStep(child.props.step);
                    }
                });
                if (!haveCurrentStep)
                    setCurrentStep(1);
            }
            else {
                setCurrentStep(1);
            }
        }
    }, [children]);
    if (centered) {
        return (React.createElement("section", { className: centerClasses },
            React.createElement("div", { className: classes, ...others },
                children,
                React.createElement("div", { className: 'step-count' },
                    currentStep,
                    "/",
                    nbChild))));
    }
    return (React.createElement("div", { className: classes, ...others },
        children,
        React.createElement("div", { className: 'step-count' },
            currentStep,
            "/",
            nbChild)));
};
export default Stepper;
//# sourceMappingURL=Stepper.js.map